import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { GrupoService } from '../../../../../../services/grupo.service';
import { SolicitudService } from '../../../../../../services/solicitud.service';
import { EmpresaService } from '../../../../../../services/empresa.service';
import { Solicitud } from '../../../../../../models/solicitud';
import { DataTableDirective } from 'angular-datatables';


@Component({
	selector: 'app-solicitudrep',
	templateUrl: './solicitudrep.component.html',
	styleUrls: ['./solicitudrep.component.css']
})
export class SolicitudrepComponent implements OnInit {
	public identity;
	public token;
	public status;
	public message_success;
	public message_error;
	public solicitud_id;
	public image;
	public imageToShow: any;
	public solicitud: Solicitud;
	public empresas: any;
	public dtOptions: DataTables.Settings = {};
	public dtTrigger: Subject<any> = new Subject();

	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _grupoService: GrupoService,
		private _solicitudService: SolicitudService,
		private _empresaService: EmpresaService
	) {
		this.identity = this._grupoService.getIdentity();
		this.token = this._grupoService.getToken();
		this.solicitud = new Solicitud(1, 0, '', '', '', '', '', '', '', '', '');
	}

	ngOnInit() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5
		}
		this.getSolicitud();
		this.getEmpresas();
		this.getImage();
	}

	getSolicitud() {
		this._route.params.subscribe(params => {

			this.solicitud_id = +params['solicitudrep_id'];

			this._solicitudService.getSolicitud(this.token, this.solicitud_id).subscribe(
				response => {
					// Obtener el token 
					if (response.status == 'success') {
						this.solicitud = response.solicitud;
					}
				},
				error => {
					if (error['status'] == 401) {
						this._router.navigate(['logout/1']);
					} else {
						this.message_error = error;
					}
				}
			);
		});
	}

	getImage() {
		this._solicitudService.getImage(this.token, this.solicitud_id).subscribe(
			response => {
				// Obtener el token 
				this.image = response;
				this.createImageFromBlob(this.image);
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.message_error = error;
				}
			}
		);
	}

	getEmpresas() {
		this._empresaService.getEmpresas(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.empresas = response.empresas;
					this.dtTrigger.next();
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.message_error = error;
				}
			}
		);
	}

	createImageFromBlob(image: Blob) {
		let reader = new FileReader();
		reader.addEventListener("load", () => {
			this.imageToShow = reader.result;
		}, false);

		if (image) {
			reader.readAsDataURL(image);
		}
	}

	addEmpresa() {
		this._empresaService.assignEmpresa(this.token, this.solicitud).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					alert(response.message);
					window.location.href = "./panel_de_control/peticiones-representantes";
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.message_error = error;
				}
			}
		);
	}

}
